import { useRef, useState, useEffect } from "react";

export function useVideoPlayer() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [playing, setPlaying] = useState(false);
  const [current, setCurrent] = useState(0);

  const togglePlay = () => {
    const v = videoRef.current;
    if (!v) return;
    if (playing) v.pause();
    else v.play();
    setPlaying(!playing);
  };

  const seekTo = (t: number) => {
    if (videoRef.current) videoRef.current.currentTime = t;
    setCurrent(t);
  };

  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;
    const onPlay = () => setPlaying(true);
    const onPause = () => setPlaying(false);
    v.addEventListener("play", onPlay);
    v.addEventListener("pause", onPause);
    return () => {
      v.removeEventListener("play", onPlay);
      v.removeEventListener("pause", onPause);
    };
  }, []);

  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;
    const handle = () => setCurrent(v.currentTime);
    v.addEventListener("timeupdate", handle);
    v.addEventListener("seeking", handle);
    return () => {
      v.removeEventListener("timeupdate", handle);
      v.removeEventListener("seeking", handle);
    };
  }, []);

  return { videoRef, playing, current, setCurrent, togglePlay, seekTo };
}